// src/components/SearchBar.jsx
import React from "react";

export default function SearchBar({
  value,
  onChange,
  onSubmit,
  placeholder,
  isLoading = false,
  containerStyle = {},
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit && onSubmit();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#fff",
        borderRadius: 24,
        padding: "6px 12px",
        boxShadow: "0 1px 4px rgba(0,0,0,.3)",
        ...containerStyle,
      }}
    >
      <span style={{ fontSize: 20, color: "#666", marginRight: 8 }}>🔍</span>
      <input
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        style={{ flex: 1, border: "none", outline: "none", fontSize: 16, background: "transparent" }}
      />
      {isLoading ? (
        <div
          style={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            border: "3px solid #ccc",
            borderTopColor: "#2563EB",
            animation: "spin 0.9s linear infinite",
          }}
        />
      ) : (
        <span
          onClick={() => onSubmit && onSubmit()}
          title="Search"
          style={{ fontSize: 20, color: "#666", cursor: "pointer" }}
        >
          ⏎
        </span>
      )}

      {/* local keyframes so the spinner works wherever this renders */}
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}